import { hide, slideDown, slideUp } from './helper';

/**
 * Accordion
 *
 * @param {string} accGroup - Main Class-String used for wrap. Class for Wrap. Subclasses for items, trigger and body depends on this in BEM Structure.
 *
 * @description Inits all accorion elements on page which doesn´t have the initialized class.
 *
 * @example Structure
 * <div class="accordion">
 *   <div class="accordion__item accordion__item--active">
 *     <div class="accordion__item__title">
 *       ...
 *     </div>
 *     <div class="accordion__item__body">
 *       ...
 *     </div>
 *   </div>
 *   <div class="accordion__item">
 *     <div class="accordion__item__title">
 *       ...
 *     </div>
 *     <div class="accordion__item__body">
 *       ...
 *     </div>
 *   </div>
 * </div>
 *
 * @author Alexander Solbrig <asolbrig@mpunkt.com>
 * @since 1.0.0
 */
const initAccordion = (accGroup = 'accordion', duration = 500) => {
    // check if wrap elements exist and loop through them if they exist
    const accGroupEle = document.querySelectorAll('.' + accGroup);
    if (accGroupEle) {
        accGroupEle.forEach((accGroupItem) => {
            // check if items elements exist and loop through them if they exist
            const accItem = accGroup + '__item';
            const accItemEle = accGroupItem.querySelectorAll('.' + accItem);
            if (accItemEle) {
                accItemEle.forEach((accItemItem) => {
                    // check for trigger and body elements
                    const accTriggerEle = accItemItem.querySelector('.' + accItem + '__title');
                    const accBodyEle = accItemItem.querySelector('.' + accItem + '__body');

                    if (accTriggerEle && accBodyEle) {
                        // set display none for none active elements
                        if (!accItemItem.classList.contains(accItem + '--active')) {
                            hide(accBodyEle);
                        }

                        // click event
                        if (!accTriggerEle.classList.contains('form-submit')) {
                            // bind new click event
                            accTriggerEle.addEventListener('click', () => {
                                triggerAccordion(accTriggerEle, accGroup, duration);
                            });
                        }

                        // set initialized class
                        accGroupItem.classList.add(accGroup + '--initialized');
                    }
                });
            }
        });
    }
};

/**
 * triggerAccordion
 *
 * @param accTrigger {HTMLElement} - HTML-Element which is clicked to trigger the accordion action
 * @param accGroup {string} - Main Class-String used for wrap. Class for Wrap. Subclasses for items, trigger and body depends on this in BEM Structure.
 *
 * @description Trigger action for accordion.
 *
 * @author Alexander Solbrig <aexl@dotdecay.com>
 * @since 1.0.0
 */
const triggerAccordion = (accTrigger, accGroup, duration = 500) => {
    const accItemEle = accTrigger.parentElement;
    if (!accItemEle.classList.contains('accordion__item--active')) {
        const accGroupEle = accTrigger.closest('.' + accGroup);

        if (accTrigger && accGroupEle) {
            if (accItemEle) {
                accItemEle.classList.add('GREAT');

                const activeItemClass = accGroup + '__item--active';
                // reset currently active items
                const activeElements = accGroupEle.querySelectorAll('.' + activeItemClass);
                if (activeElements) {
                    activeElements.forEach((activeElement) => {
                        const activeElementBody = activeElement.querySelector('.' + accGroup + '__item__body');
                        slideUp(activeElementBody, duration);
                        setTimeout(function () {
                            activeElement.classList.remove(activeItemClass);
                        }, 5);
                    });
                }

                accItemEle.classList.add(activeItemClass);
                slideDown(accItemEle.querySelector('.' + accGroup + '__item__body'), duration, 'ease', () => {
                    const dataArea = accItemEle.dataset.area;
                    const dataValue = accItemEle.dataset.accordion;
                    if (dataArea) {
                        /*fetch(BASE_PATH + 'ajax/helper/additional/ajax.saveAccordion', {
                         method: 'POST',
                         body: JSON.stringify({
                         dataArea: dataArea,
                         dataValue: dataValue,
                         }),
                         }).then(function(response) {
                         return response.text();
                         });*/
                    }
                });
            }
        }
    }
};

export { initAccordion, triggerAccordion };